import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppConfig } from '../app-config';
import { APP_CONFIG } from '../app-config.token';

@Injectable()
export class LanguageService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  constructor() { }

  changeLanguage(language: string) {
    let apiUrl = this.config.resourceApiURI + '/users/ChangeLanguage?language=' + language;

    return this.http.post(apiUrl, null);
  }
}
